import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["backgroundColor", "children", "css", "pageTopInset", "sectionBottomOffset", "sectionYInset"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import SectionStyled from './Section.styled';
import { Box, Container } from '../../';
import { jsx as _jsx } from "react/jsx-runtime";
var Section = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var backgroundColor = _ref.backgroundColor,
      children = _ref.children,
      css = _ref.css,
      pageTopInset = _ref.pageTopInset,
      sectionBottomOffset = _ref.sectionBottomOffset,
      sectionYInset = _ref.sectionYInset,
      props = _objectWithoutProperties(_ref, _excluded);

  var pageOptions = {
    1200: {
      '@initial': '400',
      '@md': '800',
      '@xl': '1200'
    }
  };
  var sectionSpacings = {
    1600: {
      '@initial': '800',
      '@md': '1200',
      '@xl': '1600'
    },
    1200: {
      '@initial': '800',
      '@lg': '1200'
    },
    800: {
      '@initial': '600',
      '@lg': '800'
    }
  };
  var spacings = {};

  if (pageTopInset) {
    spacings.insetTop = pageOptions[pageTopInset];
  }

  if (sectionYInset) {
    spacings.insetY = sectionSpacings[sectionYInset];
  }

  if (sectionBottomOffset) {
    spacings.offsetBottom = sectionSpacings[sectionBottomOffset];
  }

  var backgroundStyle = {};

  if (backgroundColor) {
    backgroundStyle.backgroundColor = backgroundColor;
  }

  return /*#__PURE__*/_jsx(SectionStyled, _objectSpread(_objectSpread({
    asChild: true,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({}, spacings), {}, {
      css: _objectSpread(_objectSpread({}, css), backgroundStyle),
      children: /*#__PURE__*/_jsx(Container, {
        children: children
      })
    }))
  }));
});
Section.displayName = 'Section';
export default Section;